export const lastColMaxWidth = "110px";
